import { render } from "./ResultsView.vue?vue&type=template&id=3a048690&scoped=true"
import script from "./ResultsView.vue?vue&type=script&lang=js"
export * from "./ResultsView.vue?vue&type=script&lang=js"

import "./ResultsView.vue?vue&type=style&index=0&id=3a048690&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a048690"]])

export default __exports__